/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"CIconButton":"CIconButton_VrDN6","button":"button_hXYHF","text":"text_lqQYx","hideTextOnMobile":"hideTextOnMobile_SfYhM"};